//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

const DEFAULT_SKIDDING_OFFSET = 0;
const DEFAULT_DISTANCE_OFFSET = parseInt(theme.spacings[2], 10);

/**
 * The offset values for a Popover.
 *
 * @property offset.skidding The position that a Popover should be placed along its target.
 * @property offset.distance The position that a Popover should be placed from its target.
 *
 * Ex: Given a popover with 'right-start' positioning, { skidding: 8, distance: 16 } will
 * place the top left corner of the Popover 8px from the top of the target and 16px away
 * from the right side of the target.
 *
 * See Popper docs for more info: https://popper.js.org/docs/v2/modifiers/offset/
 */
export interface IPopoverOffset {
  skidding?: number;
  distance?: number;
}

/**
 * Tippy expects a [skidding, distance] tuple as its offset prop, so this helper defaults
 * the offset values with our standardized offset and converts the interface to that structure.
 */
export const popoverOffsetToTippyOffset = ({
  skidding = DEFAULT_SKIDDING_OFFSET,
  distance = DEFAULT_DISTANCE_OFFSET,
}: IPopoverOffset): [number, number] => [skidding, distance];
